import React, { useState } from 'react';
import { FiSettings } from 'react-icons/fi';

import Dropdown from '~components/dropdown';

import Report from './options/report';
import Block from './options/block';
import Delete from './options/delete';

const ChatOptions = ({ isLoading }) => {
  const [visible, setVisible] = useState(false);

  if (isLoading) return null;

  return (
    <div className="c-chat-container__options">
      <Dropdown.Container
        placement="bottom-end"
        visible={visible}
        onVisibleChange={setVisible}
        optionsClassName="c-context-menu c-chat-container__context-menu"
        className="c-btn c-btn--text c-chat-container__settings-button"
        toggleLabel="Chat options"
        menuLabel="Chat options"
      >
        <Dropdown.Toggle>
          <FiSettings aria-hidden="true" />
        </Dropdown.Toggle>
        <Dropdown.Content>
          <div className="c-vertical-nav c-context-menu__nav">
            <Report />
            <Block />
            <Delete />
          </div>
        </Dropdown.Content>
      </Dropdown.Container>
    </div>
  );
};

export default ChatOptions;
